var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStatutGrisLieLot(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2,13.8c0.5,0.5,0.5,1.2,0,1.7c0,0,0,0,0,0C9.8,16,9,16,8.5,15.5c0,0,0,0,0,0C6,13.1,6,9.2,8.5,6.7c0,0,0,0,0,0l0,0 l4.4-4.4c2.4-2.4,6.4-2.4,8.8,0s2.4,6.4,0,8.8l0,0L19.8,13c0-1-0.2-2-0.5-3l0.6-0.6c1.4-1.5,1.3-3.9-0.2-5.3c-1.4-1.3-3.6-1.3-5,0 l-4.4,4.4C8.8,10,8.8,12.3,10.2,13.8C10.2,13.8,10.2,13.8,10.2,13.8 M13.8,8.5C14.2,8,15,8,15.5,8.5c0,0,0,0,0,0 c2.4,2.4,2.4,6.4,0,8.8c0,0,0,0,0,0l0,0l-4.4,4.4c-2.4,2.4-6.4,2.4-8.8,0s-2.4-6.4,0-8.8L4.2,11c0,1,0.2,2,0.5,3l-0.6,0.6 c-1.4,1.5-1.3,3.9,0.2,5.3c1.4,1.3,3.6,1.3,5,0l4.4-4.4c1.5-1.4,1.5-3.8,0-5.2c0,0,0,0,0,0C13.3,9.7,13.3,9,13.8,8.5 C13.7,8.5,13.7,8.5,13.8,8.5L13.8,8.5z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatutGrisLieLot);
export default __webpack_public_path__ + "static/media/statut_gris_lie-lot.e65e052b.svg";
export { ForwardRef as ReactComponent };